import {LiveItemType} from "../interfaces/live/LiveItem";
import {OrderIndex} from "@/order/interfaces/Order";
import {
    HomeInterviewInstanceItem,
    HomeOrderItem,
    HomeSurveyAnswerInstanceItem,
    OrderCreatedBroadcastEvent
} from "@/home/interfaces";
import {InterviewInstance} from "@/interview/interfaces/interview";
import {SurveyAnswerInstance} from "@/core/interfaces/survey/Survey";
import {ConsumerLightWeight} from "@/core/interfaces/consumers/Consumer";
import {Sharing} from "@/core/interfaces/Sharing";
import {SellinOffer} from "@/core/interfaces/SellinOffer";
import {User} from "@/core/interfaces/User";

/**
 * Live item mapper service.
 */
export default function () {
    return {
        newOrder(id: number, order: OrderIndex | OrderCreatedBroadcastEvent): HomeOrderItem {
            return {
                id,
                type: LiveItemType.ORDER_CREATED,
                data: order
            };
        },
        newInterviewInstance(id: number, instance: InterviewInstance & {
            consumer: ConsumerLightWeight
        }): HomeInterviewInstanceItem {
            return {
                id,
                type: LiveItemType.INTERVIEW_INSTANCE,
                data: instance
            };
        },
        newSurveyInstance(id: number, instance: SurveyAnswerInstance): HomeSurveyAnswerInstanceItem {
            return {
                id,
                type: LiveItemType.SURVEY_ANSWER_INSTANCE,
                data: instance
            };
        },
        newSharingRequest(id: number, sharing: Sharing) {
            return {
                id,
                type: LiveItemType.SHARING,
                data: sharing
            };
        },
        newSellinOffer(id: number, sellin: Partial<SellinOffer>) {
            return {
                id,
                type: LiveItemType.SELLIN,
                data: sellin
            };
        },
        newPatientUser(id: number, user: Partial<User>) {
            return {
                id,
                type: LiveItemType.PATIENT_USER,
                data: user
            };
        },
        newTask(task: any): any {
            if (!task?.taskable) {
                return null;
            }

            if (task.taskable_type === 'order') {
                return this.newOrder(task.id, task.taskable);
            } else if (task.taskable_type === 'survey-answer') {
                return this.newSurveyInstance(task.id, task.taskable);
            } else if (task.taskable_type === 'interview-instance') {
                return this.newInterviewInstance(task.id, task.taskable);
            } else if (task.taskable_type === 'sharing') {
                return this.newSharingRequest(task.id, task.taskable);
            } else if (task.taskable_type === 'sellin') {
                return this.newSellinOffer(task.id, task.taskable);
            } else if (task.taskable_type === 'patient_user') {
                return this.newPatientUser(task.id, {...task.taskable, created_at: task.created_at });
            }
        }
    };
}
